import { useState, useEffect } from "react";

const ScrollProgress = () => {
    const [scrollWidth, setScrollWidth] = useState(0);

    const updateScrollProgress = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const progress = (scrollTop / scrollHeight) * 100;
        setScrollWidth(progress);
    };

    useEffect(() => {
        window.addEventListener("scroll", updateScrollProgress);
        return () => window.removeEventListener("scroll", updateScrollProgress);
    }, []);

    return (
        <div 
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: `${scrollWidth}%`,
                height: "6px",
                background: 'linear-gradient(140deg, #6C1EB2, #D14FA0)',
                boxShadow: 'linear-gradient(140deg, #6C1EB2, #D14FA0)', 
                zIndex: 9999,
                transition: "width 0.2s ease-out",
                borderRadius: "5px", 
            }}
        />
    );
};

export default ScrollProgress;
